
















import { Component, Prop, Vue } from 'vue-property-decorator';
import { GetGoodsTypeSelectBoxByShop } from '@/api/select';

// 报价模块的货物类型
@Component({
    name: 'ShopSelect',
    components: {}
})
export default class ShopSelect extends Vue {
    @Prop({
        type: [Number, String],
        default: ''
    })
    public value!:any;

    public options: Array<any> = [];

    private mounted() {
        this.init();
    }

    private async init() {
        try {
            const params: any = {};
            const { Data } = await GetGoodsTypeSelectBoxByShop(params);
            Data.map((item) => {
                item.Value = String(item.Value);
                return item;
            });
            this.options = Data;
            this.$emit('loaded');
            this.handleChange(Data[0].Value);
        } catch (err) {
            console.warn(err);
            this.handleChange(null);
        }
    }

    public handleChange(val: any) {
        this.$emit('input', val);
        this.$emit('inputName');
    }
}
